<template>
  <div class="pop-layout" v-if="isValidItem">
    <template v-if="layoutType === 3 && layout && item.id">
      <div
        class="pop-layout-left"
        v-show="!isLeftCollapse"
        :style="{ flex: !isRightCollapse ? widthObj3.left : 1 }"
      >
        <div v-show="!isRightCollapse" :class="['collapse-btn']" @click="collapseLeft">
          <span :class="['iconfont', 'icon-shuangzuo-line']"></span>
        </div>
        <div v-show="isRightCollapse" :class="['collapse-btn', { active: isRightCollapse }]" @click="collapseRight">
          <span :class="['iconfont', 'icon-shuangzuo-line']"></span>
        </div>
        <Pannel
          :config="layout.leftTop"
          :style="{ ...getHeight(layout.leftTop.style.height) }"
          :item="item"
        />
        <Pannel
          :config="layout.leftBottom"
          :style="{ ...getHeight(layout.leftBottom.style.height) }"
          :item="item"
        />
      </div>
      <div
        class="pop-layout-right"
        v-show="!isRightCollapse"
        :style="{ flex: !isLeftCollapse ? widthObj3.right : 1 }"
      >
        <div v-show="isLeftCollapse" :class="['collapse-btn', { active: isLeftCollapse }]" @click="collapseLeft">
          <span :class="['iconfont', 'icon-shuangyou-line']"></span>
        </div>
        <div v-show="!isLeftCollapse" :class="['collapse-btn']" @click="collapseRight">
          <span :class="['iconfont', 'icon-shuangyou-line']"></span>
        </div>
        <Pannel
          :config="layout.right"
          :item="item"
          :isQidianShowWo="isQidianShowWo"
        />
      </div>
    </template>
  </div>
</template>

<script>
import Pannel from '../pannel'
export default {
  props: {
    workbenchConfig: {
      type: Object,
      default() {
        return {}
      }
    },
    isQidianShowWo: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  components: {
    Pannel
  },
  data() {
    return {
      isLeftCollapse: false,
      isRightCollapse: false
    }
  },
  computed: {
    isValidItem() {
      return JSON.stringify(this.item) !== '{}'
    },
    pageLayout() {
      return this.workbenchConfig.page_layout || {}
    },
    layoutType() {
      return this.pageLayout.layout_type
    },
    layout() {
      return this.pageLayout.layout_config && this.pageLayout.layout_config['layout' + this.layoutType]
    },
    widthObj3() {
      if(this.layoutType === 3 && this.layout) {
        const leftTopWidth = this.layout.leftTop.style.width
        const leftBottomWidth = this.layout.leftBottom.style.width
        const rightWidth = this.layout.right.style.width
        if(leftTopWidth) {
          return this.getWidth(leftTopWidth)
        } else if(leftBottomWidth) {
          return this.getWidth(leftBottomWidth)
        } else if(rightWidth) {
          return this.getWidth(rightWidth, 'right', 'left')
        } else {
          return { left: 1, right: 1 }
        }
      } else {
        return {
          left: 1,
          right: 1
        }
      }
    }
  },
  created() {

  },
  methods: {
    getHeight(h) {
      if(!h) return {}
      if(h.type === 1) {
        return { flex: h.value }
      } else {
        return { height: h.value + 'px' }
      }
    },
    getWidth(w, p1 = 'left', p2 = 'right') {
      if(!w) return { left: 1, right: 1 }
      if(w.type === 1) {
        return { [p1]: `0 1 ${w.value}`, [p2]: 1 }
      } else {
        return { [p1]: `0 1 ${w.value + 'px'}`, [p2]: 1 }
      }
    },
    collapseRight() {
      this.isRightCollapse = !this.isRightCollapse
      if(this.isRightCollapse) {
        this.isLeftCollapse = false
      }
    },
    collapseLeft() {
      this.isLeftCollapse = !this.isLeftCollapse
      if(this.isLeftCollapse) {
        this.isRightCollapse = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pop-layout {
  display: flex;
  width: 100%;
  height: 100%;
  gap: 16px;
  .pop-layout-left {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 16px;
    .collapse-btn {
      right: 3px;
      left: unset;
      transform: translate(50%);
    }
    &:hover {
      .collapse-btn {
        display: flex;
      }
    }
  }
  .pop-layout-right {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
    &:hover {
      .collapse-btn {
        display: flex;
      }
    }
  }
  .collapse-btn {
    position: absolute;
    top: 88px;
    left: 3px;
    transform: translate(-50%);
    display: flex;
    display: none;
    justify-content: center;
    align-items: center;
    width: 28px;
    height: 28px;
    border: 1px solid #DCDEE0;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    box-shadow: 0 3px 6px -4px #0000001f, 0 6px 16px 0 #00000014, 0 9px 28px 8px #0000000d;
    &.active {
      border-color: #7AD3FF;
      background-color: #E6F8FF;
      .iconfont {
        color: #0090FF;
        font-size: 12px;
      }
    }
    .iconfont {
      color: #323233;
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Home/callPopScreenTab/popLayout/index.vue